export default "<nav>\r\n<content-container class=\"main\"></content-container>\r\n</nav>\r\n\r\n"